import { CURRENCIES } from '@experience/money-utils';

import type { Experience } from '@/shared/api/generated/api';

export const getCardPrice = (exp: Experience) => {
  const displayPrice = exp.display_price;

  if (displayPrice && displayPrice.currency in CURRENCIES) {
    return displayPrice;
  }

  return exp.price;
};
